export const resultText = [
  'Ne ferme pas cette page',
  'Quelque chose de surprenant arrive',
  'La fin du voyage arrive, alors profitons encore un peu',
];
